import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Page from "../../components/general/page";
import ReportsPage from "../../components/report";

const ReportsView = ( props ) => {
  const {pageRef} = props;
  const location = useLocation();
  const navigate = useNavigate();
  const queryUrl = new URLSearchParams(location.search);

  const [model, setModel] = useState(queryUrl.get("model"));
  const detailOnLoad = queryUrl.get("detail") === "true" || false;
  const [title, setTitle] = useState("REPORT");
  const [backArrowClicked, setBackArrowClicked] = useState(false);
  const [enableBackArrow, setEnableBackArrow] = useState(false);
  const [additionalBackSearch, setAdditionalBackSearch] = useState("");

  const backButtonShow = () => {
    setEnableBackArrow(true);
    setBackArrowClicked(false);
  };

  const actionBackArrow = () => {
    if (enableBackArrow) {
      setEnableBackArrow(false);
      setBackArrowClicked(true);
    }
  };

  const paramsFromUrl = () => {
    let objToLoad = {};
    for (const param of queryUrl.keys()){
      if (param !== "model" && param !== "detail"){
        objToLoad[param] = queryUrl.get(param);
      }
    }
    return objToLoad;
  };

  if (!model){
    navigate("/reports/home");
    return <></>;
  }

  return (
    <Page
      pageRef={pageRef}      
      title={title}
      className="contentStructure settings"
      backUrl={
        enableBackArrow
          ? "/reports?model=" + model + additionalBackSearch
          : model
            ? "/reports/home"
            : ""
      }
      actionClick={() => actionBackArrow()}
    >
      <ReportsPage
        setTitle={setTitle}
        backButtonShow={backButtonShow}
        backArrowClicked={backArrowClicked}
        setAdditionalBackSearch={setAdditionalBackSearch}
        model={model}
        setModel={setModel}        
        paramsFromUrl={paramsFromUrl()}
        detailOnLoad={detailOnLoad}
      />
    </Page>
  );
};

export default ReportsView;
